import { render } from "./ModulInfoBildText3Spaltig.vue?vue&type=template&id=6a0b27ec"
import script from "./ModulInfoBildText3Spaltig.vue?vue&type=script&lang=js"
export * from "./ModulInfoBildText3Spaltig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__